<template>
  <div class="img" style="display: flex;align-items: center">
    <img src="images/activities/20191126_20191212/img.png" alt="" style="width: 100%;">
  </div>
</template>

<script>
  export default {
    name: "hd20191126_20191212"
  }
</script>

<style scoped>
  #box{
    display: flex;
    align-items: center;
  }
  .box{
    width: 100vw;
    height: 141vw;
    box-sizing: border-box;
    border: 4vw solid #00813a;
    background: #ffffff;
    position: relative;
  }
  .logo{
    width: 34vw;
    height: 10vw;
    position: relative;
  }
  .logo>img{width: 100%;}
  .logo-box{
    width: 34vw;
    height: 10vw;
    display: flex;
    align-items: center;
    position: absolute;
    top: 0;
  }
  .logo-box>p{font-size: 4vw;color: #ffffff;}

  .title{
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #00813a;
    font-weight: bold;
  }
  .title>p:first-child{
    font-size: 12vw;
    letter-spacing: 1vw;
    margin-top: 5vw;
  }
  .title>p:last-child{
    font-size: 8vw;
  }

  ._92{
    margin-top: 7vw;
  }
  .title_92{
    width: 27vw;
    height: 7vw;
    background: #006937;
    display: flex;
  }
  .title_92>p{
    flex: 1;
    font-size: 5vw;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .arrows{
    width: 2vw;
    border-top: 3.5vw solid transparent;
    border-bottom: 3.5vw solid transparent;
    border-right: 2vw solid #ffffff;
  }
  .content{
    margin-left: 3vw;
    margin-top: 1vw;
  }
  .row{
    display: flex;
    align-items: center;
    margin-top: 3vw;
  }
  .prefix{
    width: 5vw;
    height: 5vw;
    box-sizing: border-box;
    border: 1px solid black;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 5vw;
    margin-right: 1.5vw;
  }

  ._95-98{
    margin-top: 4vw;
  }
  .title_95-98{
    width: 32vw;
    height: 7vw;
    background: #006937;
    display: flex;
  }
  .title_95-98>p{
    flex: 1;
    font-size: 5vw;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .bottom{
    position: absolute;
    bottom: 0;
  }

</style>
